import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'mb-contact-box-line',
  styleUrls: ['./contact-box-line.component.scss'],
  templateUrl: './contact-box-line.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactBoxLineComponent implements OnInit {

  @Input() tag?: string
  @Input() labelBold?: boolean
  @Input() bold?: boolean
  @Input() noLabel?: boolean
  @Input() inputType: 'text' | 'link' | 'mail' | 'tel' = 'text'
  @Input() text: string | undefined
  @Input() value: string | undefined
  @Input() cmsLinkType: string | undefined

  dataCy?: string

  ngOnInit (): void {
    this.labelBold = this.labelBold !== undefined
    this.bold = this.bold !== undefined
    this.noLabel = this.noLabel !== undefined
    this.dataCy = this.tag?.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`) ?? ''
  }
}
